import ListDataDependentMaster from "./ListDependentMaster";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { getSadaadData } from "../../../../store/Api";
import { setBreadCrumb } from "../../../../store/userSlice";
import { getDpendentMasterData } from "../../../../store/Api";

export default function DependentMaster() {
  const dependentMaster = useSelector((state) => state.dependentMasterSummary);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState({
    updateData: false,
    uploadFile: false,
    listData: false,
    loadingId: "",
  });
  const token = localStorage.getItem("nodeToken");

  const titleBorder = [
    { label: "DEPENDENT MASTER SUMMARY", link: "/dashboard/dependent-master" },
  ];
  useEffect(() => {
    dispatch(setBreadCrumb(titleBorder));
    dispatch(getDpendentMasterData(token));
  }, []);

  return (
    <>
      <div className={`ml-5 mr-5 `}>
        <ListDataDependentMaster
          list={dependentMaster}
          loading={loading}
          titles={[
            "S.NO.",
            "DEPENDENT NAME",
            "DEPENDENT DATE OF BIRTH",
            "DEPENDENT IQAMA NUMBER",
            "RELATION",
            "CLASS",
            "IQAMA NUMBER",
            "INSURANCE APPLY DATE",
            "POLICY NUMBER",
            "INSURANCE ISSUE DATE",
            "INSURANCE COMPANY NAME",
            "MEMBERSHIP ID",
            "INSURED ID",
            "INSURANCE STATUS",
          ]}
          token={token}
        />
      </div>
    </>
  );
}
